/**
 * Debug Info Module
 * Handles AJAX request for sync debug information.
 */

( function( $ ) {
	'use strict';

	const DebugInfo = {
		/**
		 * Initialise the debug info handler.
		 *
		 * @param {Object} config Configuration object with ajaxUrl and nonce.
		 */
		init( config ) {
			this.ajaxUrl = config.ajaxUrl;
			this.nonce = config.nonce;

			this.$button = $( '#qala-get-debug-info' );
			this.$spinner = $( '#qala-debug-info-spinner' );
			this.$result = $( '#qala-debug-info-result' );

			if ( ! this.$button.length ) {
				return;
			}

			this.bindEvents();
		},

		/**
		 * Bind event handlers.
		 */
		bindEvents() {
			this.$button.on( 'click', e => {
				e.preventDefault();
				this.handleDebugInfoRequest();
			} );
		},

		/**
		 * Handle the debug info AJAX request.
		 */
		handleDebugInfoRequest() {
			this.$button.prop( 'disabled', true );
			this.$spinner.addClass( 'is-active' );
			this.$result.hide();

			$.ajax( {
				url: this.ajaxUrl,
				type: 'POST',
				data: {
					action: 'qala_blocket_connector_get_debug_info',
					nonce: this.nonce,
				},
				success: response => {
					this.$spinner.removeClass( 'is-active' );
					this.$button.prop( 'disabled', false );

					if ( response.success ) {
						this.displayDebugInfo( response.data );
					} else {
						this.displayError(
							response.data.message || 'Unknown error'
						);
					}
				},
				error: () => {
					this.$spinner.removeClass( 'is-active' );
					this.$button.prop( 'disabled', false );
					this.displayError( 'Request failed' );
				},
			} );
		},

		/**
		 * Display debug information.
		 *
		 * @param {Object} data Debug data from the server.
		 */
		displayDebugInfo( data ) {
			let html = '<div class="qala-debug-info-card">';
			html += '<h4 class="qala-debug-info-title">Sync Overview</h4>';
			html += this.buildTable( [
				{
					label: 'Products in API:',
					value: data.api_product_count,
				},
				{
					label: 'Would be created:',
					value: data.products_to_create_count,
					class: 'qala-count-create',
				},
				{
					label: 'Would be updated:',
					value: data.products_to_update_count,
					class: 'qala-count-update',
				},
				{
					label: 'Would be deleted:',
					value: data.products_to_delete_count,
					class: 'qala-count-delete',
				},
			] );

			html += '<hr class="qala-debug-info-divider">';
			html += '<h4 class="qala-debug-info-heading">WooCommerce Status</h4>';
			html += this.buildTable( [
				{
					label: 'Total products:',
					value: data.woo_total_products,
				},
				{
					label: 'API-synced products:',
					value: data.woo_api_products,
				},
			] );

			html += '<hr class="qala-debug-info-divider">';
			html += '<h4 class="qala-debug-info-heading">Sync Settings</h4>';
			html += this.buildTable( [
				{
					label: 'Last sync:',
					value: data.last_sync_date,
				},
				{
					label: 'Delete setting:',
					value: data.delete_setting_label,
				},
				{
					label: 'Unique identifier:',
					value: data.unique_identifier,
				},
				{
					label: 'Batch size:',
					value: data.batch_size,
				},
				{
					label: 'Estimated batches:',
					value: data.batch_count,
				},
			] );

			html += '<hr class="qala-debug-info-divider">';
			html +=
				'<h4 class="qala-debug-info-heading">Taxonomy & Term Changes</h4>';
			html += this.buildTable( [
				{
					label: 'Categories in API:',
					value: data.categories_in_api,
				},
				{
					label: 'Categories in WooCommerce:',
					value: data.categories_in_woo,
				},
				{
					label: 'Categories to create:',
					value: data.categories_to_create,
					class: 'qala-count-create',
				},
				{
					label: 'Attributes in API:',
					value: data.attributes_in_api,
				},
				{
					label: 'Attributes in WooCommerce:',
					value: data.attributes_in_woo,
				},
				{
					label: 'Attributes to create:',
					value: data.attributes_to_create,
					class: 'qala-count-create',
				},
				{
					label: 'Attribute terms in API:',
					value: data.attribute_terms_in_api,
				},
				{
					label: 'Attribute terms to create:',
					value: data.attribute_terms_to_create,
					class: 'qala-count-create',
				},
			] );

			html += '</div>';

			this.$result.html( html ).show();
		},

		/**
		 * Build a table from data array.
		 *
		 * @param {Array} rows Array of row objects with label, value, and optional class.
		 * @return {string} HTML table string.
		 */
		buildTable( rows ) {
			let html = '<table class="qala-debug-info-table">';
			rows.forEach( ( row, index ) => {
				const isLast = index === rows.length - 1;
				const valueClass = row.class ? ' class="' + row.class + '"' : '';
				html += '<tr>';
				html +=
					'<td class="qala-debug-info-label' +
					( ! isLast ? ' qala-debug-info-border' : '' ) +
					'"><strong>' +
					row.label +
					'</strong></td>';
				html +=
					'<td class="qala-debug-info-value' +
					( ! isLast ? ' qala-debug-info-border' : '' ) +
					'"' +
					valueClass +
					'>' +
					row.value +
					'</td>';
				html += '</tr>';
			} );
			html += '</table>';
			return html;
		},

		/**
		 * Display an error message.
		 *
		 * @param {string} message Error message to display.
		 */
		displayError( message ) {
			this.$result.html(
				'<strong class="qala-debug-info-error">Error: ' +
					message +
					'</strong>'
			).show();
		},
	};

	// Initialise on document ready.
	$( document ).ready( function() {
		// Check if config is available (localised from PHP).
		if (
			typeof QalaBlocketConnectorDebugInfo !== 'undefined' &&
			QalaBlocketConnectorDebugInfo
		) {
			DebugInfo.init( QalaBlocketConnectorDebugInfo );
		}
	} );
}( jQuery ) );

